/* Scroll functions */
(function($) {
    'use strict'

    let slide_speed = 300

    document.querySelectorAll('.module-trading-units').forEach((module) => {
        let accordion_items = module.querySelectorAll('.product-informations-container a')

        if (accordion_items.length > 0) {
            accordion_items.forEach((accordion_item) => {
                accordion_item.addEventListener('click', (ev) => {
                    ev.preventDefault()
                    if (accordion_item.closest('li').classList.contains('is-active')) {
                        accordion_item.closest('li').classList.remove('is-active')
                        let details = accordion_item.closest('li').querySelector('ul')
                        $(details).slideUp(slide_speed)
                    } else {
                        accordion_item.closest('li').classList.add('is-active')
                        let details = accordion_item.closest('li').querySelector('ul')
                        $(details).slideDown(slide_speed)
                    }

                    return false
                })
            })
        }
    })
})(jQuery)